import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionCompanyComponent } from './section-company.component';

@NgModule({
  declarations: [SectionCompanyComponent],
  imports: [CommonModule],
  exports: [SectionCompanyComponent],
})
export class SectionCompanyModule {}
